import copyToClipboard from 'copy-to-clipboard'; // eslint-disable-line no-restricted-imports

// v4 made the window.prompt fallback opt-in.  Keep it on: call sites show
// "Copied" without checking the result.
export const copy = (text: string) =>
  copyToClipboard(text, { fallbackToPrompt: true });
